import { Highcharts } from "extensions/highcharts";
import { _ } from "extensions/underscore";

import { accounting } from "common/utils";
import { toHex } from "common/colors";
import { v2 } from "common/config/api";
import strings from "common/strings";
import { amount } from "common/formats";

import { DefaultTypeConfig } from "./default";

export const net_settled_cash = function(options) {
    const opts = {
        ...options
    };
    
    return new DefaultTypeConfig(opts, {
        urlRoot: "analytics/cashflow",
        api_endpoint(pivot = "date_time") {
            return v2.cashflow.byPivot(Array.isArray(pivot) ? pivot : [pivot]);
        },
        totals: {
            refunds_amount: _.partial(accounting.refunds.getTotalValue, _, "amount"),
            refunds_count: _.partial(accounting.refunds.getTotalValue, _, "count"),
            sales_amount: _.partial(accounting.sales.getTotalValue, _, "amount"),
            sales_count: _.partial(accounting.sales.getTotalValue, _, "count"),
            chargebacks_amount: _.partial(accounting.chargebacks.getTotalValue, _, "amount"),
            fees_amount: accounting.fees.getTotalFeesAmount
        },
        quick: {
            chart: {
                type: "AreaLine",
                series: [{
                    type: "area",
                    pointFormat: [DefaultTypeConfig.date_unix, DefaultTypeConfig.keyToFunc["total_amount"]()],
                    extend: {
                        fillColor: Highcharts.Color(toHex("canvas-white")).setOpacity(0.15).get("rgba"),
                        color: toHex("canvas-white")
                    }
                }]
            },
            data: {
                widgetValueTemplate: "<div class='rate'>{{ data.netAmount }}</div>",
                widgetValueTemplateData: {
                    netAmount: {
                        value: accounting.sales.netAmount,
                        type: "amount"
                    }
                }
            },
            reactProps: {
                chartField: "total_amount",
                chartFieldToggle: false,
                chartFieldDataType: "amount",
                fillColor: Highcharts.Color(toHex("canvas-white")).setOpacity(0.15).get("rgba"),
                color: toHex("canvas-white"),
                extend: {}
            }
        },
        table: {
            columns: [{
                id: "Actor", // This field is changed by tableView.js
                header: "", // This field is changed by tableView.js
                template(model, pivot) {
                    return DefaultTypeConfig.references.toAlias(model[pivot], pivot);
                },
                sort: "string"
            }, {
                id: accounting.sales.netAmount,
                header: strings.amount,
                format: amount,
                css: "amount",
                sort: "int"
            }]
        }
    });
};
